import React, { useEffect, useState, useMemo } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PastFromClipboard from "./PastFromClipboard";

const ActionModal = (props) => {
    const { open, handleClose, handleSubmit, actionProps } = props;

    const formInit = {
        address:
            actionProps.modalType === "delete-contract"
                ? "0x0000000000000000000000000000000000000001"
                : "",
        count: "",
    };

    const [formData, setFormData] = useState(formInit);
    const [touchedAddress, setTouchedAddress] = useState(false);
    const [touchedCount, setTouchedCount] = useState(false);

    const close = () => {
        setFormData(formInit);
        setTouchedAddress(false);
        setTouchedCount(false);
        handleClose();
    };
    const validate = useMemo(() => {
        const validAddress =
            actionProps.modalType === "transfer" ||
            actionProps.modalType === "transfer-contract"
                ? !!formData.address.match(/^0x/i) &&
                  formData.address.length > 41
                : true;
        const validCount =
            actionProps.type === "ERC1155" &&
            actionProps.modalType !== "transfer-contract" &&
            actionProps.modalType !== "delete-contract"
                ? formData.count > 0 && actionProps.count >= formData.count
                : true;
        return { validAddress, validCount };
    }, [formData, actionProps.count, actionProps.type, actionProps.modalType]);

    const change = (e) => {
        const { name, value } = e.target;
        name === "address" ? setTouchedAddress(true) : setTouchedCount(true);
        setFormData({ ...formData, [name]: value });
    };

    const submit = (e) => {
        e.preventDefault();
        setTouchedAddress(true);
        setTouchedCount(true);
        if (validate.validAddress && validate.validCount) {
            handleSubmit(formData, actionProps.modalType);
            setFormData(formInit);
            handleClose();
        }
    };
    const pastAddress = (address) => {
        setFormData({ ...formData, address });
    };
    return (
        <div>
            <Dialog open={open} onClose={close} disableEscapeKeyDown fullWidth>
                <DialogTitle>{actionProps.header}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{actionProps.text}</DialogContentText>
                </DialogContent>
                <Box sx={{ p: "0 2rem 2rem 2rem" }}>
                    <Box component="form" onSubmit={submit}>
                        { !["ERC721A", "ERC721PSI"].includes(actionProps.type) && actionProps.modalType !== "delete" &&
                            actionProps.modalType !== "delete-contract" && (
                                <>
                                    <TextField
                                        name="address"
                                        label="Address"
                                        type="text"
                                        variant="standard"
                                        sx={{ width: "80%" }}
                                        value={formData.address}
                                        onChange={change}
                                    />
                                    <PastFromClipboard
                                        setTarget={pastAddress}
                                    />
                                    {!validate.validAddress && touchedAddress && (
                                        <Typography
                                            component="p"
                                            sx={{
                                                width: "100%",
                                                color: "red",
                                                mt: "0.5rem",
                                                fontFamily: "Montserrat",
                                                fontSize: "12px",
                                                fontWeight: "400",
                                            }}
                                        >
                                            Not valid address
                                        </Typography>
                                    )}
                                </>
                            )}
                        {(((actionProps.type === "ERC1155" || ["ERC20", "ERC721A", "ERC721PSI"].includes(actionProps.type)) &&
                            actionProps.modalType !== "delete-contract" &&
                            actionProps.modalType !== "transfer-contract") ||
                            (["ERC20", "ERC721A", "ERC721PSI"].includes(actionProps.type) && actionProps.modalType === "transfer-token"))
                            && (
                                <>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            width: "100%",
                                            alignItems: "end",
                                        }}
                                    >
                                        <TextField
                                            name="count"
                                            margin="dense"
                                            label="Count"
                                            type="text"
                                            variant="standard"
                                            sx={{ width: ["ERC20", "ERC721A", "ERC721PSI"].includes(actionProps.type) ? "80%" : "80px" }}
                                            value={formData.count}
                                            onChange={change}
                                        />
                                        {
                                            !["ERC20", "ERC721A", "ERC721PSI"].includes(actionProps.type) && (
                                                <Typography
                                                    component="p"
                                                    sx={{
                                                        pl: "0.5rem",
                                                        fontFamily: "Montserrat",
                                                        fontSize: "12px",
                                                        fontWeight: "400",
                                                    }}
                                                >
                                                    (max {actionProps.count})
                                                </Typography>
                                            )
                                        }
                                    </Box>
                                    <Typography
                                        component="p"
                                        sx={{
                                            width: "100%",
                                            color: "red",
                                            mt: "0.5rem",
                                            fontFamily: "Montserrat",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                        }}
                                    >
                                        {!validate.validCount && touchedCount
                                            ? "Not valid count"
                                            : ""}
                                    </Typography>
                                </>
                            )}

                        <DialogActions>
                            <Button onClick={close}>Cancel</Button>
                            <Button type="submit">Submit</Button>
                        </DialogActions>
                    </Box>
                </Box>
            </Dialog>
        </div>
    );
};

export default ActionModal;
